import { useState, useEffect, lazy, Suspense, useContext } from "react"
import { useParams } from 'react-router'
import ThemeContext from '../context/ThemeContext';
import api from '../components/api'
import styles from '../assets/css/module/article.module.css'
const ArticleLists = lazy(() => import ('../components/Article/ArticleLists'))
const ArticleDetail = lazy(() => import ('../components/Article/ArticleDetail'))

export default function Article(props) {
    const [article_id, setArticleID] = useState(0);
    const [article_type_id, setArticleTypeID] = useState(0);
    const params = useParams();
    const { language, page, init } = useContext(ThemeContext);

    useEffect(()=>{
        if(params.articleId){
            setArticleID(params.articleId);
        }else{
          if(props.id){
            setArticleID(props.id);
          }else{
            setArticleID(0);
          }
        }
        if(props.articleType){
          setArticleTypeID(props.articleType);
        }else{
          setArticleTypeID(0);
        }
        window.addEventListener("scroll", reveal);
        reveal();
    },[]);

    function reveal() {
        var reveals = document.querySelectorAll(".reveal");
        for (var i = 0; i < reveals.length; i++) {
          var windowHeight = window.innerHeight;
          var elementTop = reveals[i].getBoundingClientRect().top;
          var elementVisible = 150;
          if (elementTop < windowHeight - elementVisible) {
            reveals[i].classList.add("active");
          } else {
            reveals[i].classList.remove("active");
          }
        }
    }

    return (
        <div className={styles["article-container"]}>
              <div className={"content reveal"}>
                  {(article_id===0)?(
                    <Suspense fallback={<h1>Loading News & Activities</h1>}>
                        <ArticleLists styles={styles} article_type_id={article_type_id} setArticleID={setArticleID} />
                    </Suspense>
                  ):(
                    <Suspense fallback={<h1>Loading Article</h1>}>
                        <ArticleDetail styles={styles} article_id={article_id} />
                    </Suspense>
                  )}
              </div>
        </div>
    )
}